<template>
  <div class="container mx-auto">
    <div class="flex justify-center">
      <div
        v-show="isOpen"
        class="fixed inset-0 flex items-center justify-center bg-sp-secondary bg-opacity-70 z-[9999]"
        role="dialog"
        aria-modal="true"
        :aria-label="message"
        @click="handleOverlayClick"
        @keydown="handleKeydown"
      >
        <div class="max-w-2xl p-4 mx-4 bg-sp-secondary text-sp-primary border border-white border-opacity-20 rounded-md shadow-xl">
          <div class="flex items-center justify-between">
            <h3 class="text-2xl"></h3>
            <button
              ref="closeButtonRef"
              @click="closeModal"
              class="close-button h-9 w-9 min-w-9"
              aria-label="Close"
            >
              <img src="../assets/close-button.png" alt="">
            </button>
          </div>
          <div class="my-4">
            {{ message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted, onUnmounted, nextTick } from 'vue'

export default {
  props: {
    message: String
  },
  setup(props, { emit }) {
    let isOpen = ref(true)
    const closeButtonRef = ref(null)
    let previouslyFocused = null

    const closeModal = () => {
      isOpen.value = false
    }

    const handleOverlayClick = (event) => {
      if (event.target === event.currentTarget) {
        closeModal()
      }
    }

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        closeModal()
        return
      }

      if (event.key === 'Tab') {
        event.preventDefault()
        closeButtonRef.value?.focus()
      }
    }

    watch(isOpen, (newValue) => {
      if (!newValue) {
        emit('closed')
      }
    })

    onMounted(async () => {
      previouslyFocused = document.activeElement
      await nextTick()
      closeButtonRef.value?.focus()
    })

    onUnmounted(() => {
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
        previouslyFocused.focus()
      }
    })

    return { isOpen, closeModal, handleOverlayClick, handleKeydown, closeButtonRef, ...props }
  }
}
</script>
